export default function initCopyButton() {
    function copyToClipboard() {
        let currentUrl = window.location.href;
        
        navigator.clipboard.writeText(currentUrl);
    }

    document.querySelector('.js-copy-to-clipboard') && document.querySelector('.js-copy-to-clipboard').addEventListener('click', (e) => {
        e.preventDefault();
        copyToClipboard();


        const notification = document.querySelector('.js-copy-notification');
        if (notification) {
            notification.classList.contains('opacity-0') && notification.classList.remove('opacity-0', 'pointer-events-none');
            setTimeout(() => {
                notification.classList.add('opacity-0', 'pointer-events-none');
            }, 1000);
        }
    });
}